'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
import { parseAsStringEnum, useQueryState } from 'nuqs';
import { ConfigureServicesSkeleton } from '@/modules/service-purchase/components/configure-services-step/configure-services';
import { ConfirmationStepSkeleton } from '@/modules/service-purchase/components/confirmation-step';
import { ProductInfoSkeleton } from '@/modules/service-purchase/components/product-info';
import { SelectOperatorStepSkeleton } from '@/modules/service-purchase/components/select-operator-step';
import { StepsTriggerListSkeleton } from '@/modules/service-purchase/components/service-purchase-wizard/steps-trigger';
import { SummaryStepSkeleton } from '@/modules/service-purchase/components/summary-step';
import { SERVICE_PURCHASE_DEFAULT_STEP, SERVICE_PURCHASE_STEP_VALUES } from '@/modules/service-purchase/lib/constants';
import { ServicePurchaseStep } from '@/modules/service-purchase/types';
import { ServiceInfoSkeleton } from '@/modules/services/components/service-info';
import { PageContent } from '@/modules/shared/components/page-containers';
function PurchaseLoadingSkeleton() {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsStringEnum(SERVICE_PURCHASE_STEP_VALUES).withDefault(SERVICE_PURCHASE_DEFAULT_STEP);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [step] = useQueryState("step", t0);
  const activeStep = step as ServicePurchaseStep;
  const isProductInfo = activeStep === ServicePurchaseStep.ProductInfo;
  const isSelectOperator = activeStep === ServicePurchaseStep.SelectOperator;
  const showNavButtons = !isProductInfo;
  let t1;
  if ($[1] !== activeStep) {
    t1 = function renderStepContent() {
      switch (activeStep) {
        case ServicePurchaseStep.ProductInfo:
          {
            return <ProductInfoSkeleton />;
          }
        case ServicePurchaseStep.SelectOperator:
          {
            return <SelectOperatorStepSkeleton />;
          }
        case ServicePurchaseStep.ConfigureServices:
          {
            return <ConfigureServicesSkeleton />;
          }
        case ServicePurchaseStep.Summary:
          {
            return <SummaryStepSkeleton />;
          }
        case ServicePurchaseStep.Confirmation:
          {
            return <ConfirmationStepSkeleton />;
          }
        default:
          {
            return <ProductInfoSkeleton />;
          }
      }
    };
    $[1] = activeStep;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderStepContent = t1;
  let t2;
  if ($[3] !== activeStep) {
    t2 = <StepsTriggerListSkeleton activeStep={activeStep} />;
    $[3] = activeStep;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !isProductInfo;
  const t4 = !isProductInfo && !isSelectOperator;
  let t5;
  if ($[5] !== isProductInfo || $[6] !== t3 || $[7] !== t4) {
    t5 = <div className="min-w-0 flex-1"><ServiceInfoSkeleton isCompacted={t3} showOperatorBadge={t4} showSelectOperatorAction={isProductInfo} /></div>;
    $[5] = isProductInfo;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== showNavButtons) {
    t6 = showNavButtons && <div className="shrink-0"><div className="flex items-center gap-2"><Skeleton className="h-9 w-16 rounded-md" /><Skeleton className="h-9 w-24 rounded-md" /></div></div>;
    $[9] = showNavButtons;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex flex-col gap-4 sm:flex-row sm:items-center">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== renderStepContent) {
    t8 = <div className="m-0 flex flex-col gap-2">{renderStepContent()}</div>;
    $[14] = renderStepContent;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t7 || $[18] !== t8) {
    t9 = <PageContent className="gap-6" aria-busy="true"><div className="flex flex-col gap-6 lg:gap-8"><div className="flex w-full flex-col gap-8">{t2}{t7}{t8}</div></div></PageContent>;
    $[16] = t2;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export { PurchaseLoadingSkeleton };